const customStyles = {
  control: base => ({
    ...base,
    backgroundColor: 'transparent',
    borderColor: 'transparent !important',
    boxShadow: 'none',
    cursor: 'pointer',
    marginLeft: 6,
    minHeight: 24,
    height: 24,
    width: 130,
    '&:hover': {
      backgroundColor: '#545b64',
    },
  }),
  dropdownIndicator: base => ({
    ...base,
    color: 'white',
    padding: '0 2px',
    '&:hover': {
      color: 'white',
    },
  }),
  clearIndicator: base => ({
    ...base,
    padding: 2,
  }),
  menu: base => ({
    ...base,
    backgroundColor: '#282828',
    border: '1px solid #545b64',
  }),
  option: (base, { isFocused, isSelected }) => ({
    ...base,
    backgroundColor: isSelected ? '#424242' : isFocused ? '#545b64' : null,
    ':active': {
      ...base[':active'],
      backgroundColor: '#424242',
    },
  }),
  valueContainer: base => ({
    ...base,
    justifyContent: 'flex-end',
    padding: '0px 6px',
  }),
  input: base => ({
    ...base,
    color: 'white',
    margin: '0 -6px 0 0',
    padding: 0,
  }),
  singleValue: base => ({
    ...base,
    color: 'white',
  }),
}

export default customStyles
